import type { ReactElement } from 'react';
import type { IMultiFactor, IRebalancedPortfolioMultifactorRuleInput } from '../../../../../generated/graphql.tsx';
import type { LoadMultifactorFormInputFields } from 'components/market/asset/assetScreener/AssetScreenerService.ts';
import FormStaticSingleAutocomplete from 'components/technical/form/FormStaticSingleAutocomplete.tsx';
import FormInput from 'components/technical/form/FormInput.tsx';
import type {
  MultifactorBasedFormInputFields,
  MultifactorBasedFormOutputFields,
} from './MultifactorBasedPortfolioSchema.validation.ts';
import { createMultifactorOptions } from 'components/market/asset/assetScreener/MultifactorService.ts';
import { useFormContext } from 'react-hook-form';
import type { GInputProps } from 'components/technical/inputs/GInput/GInput.props.ts';
import type { GAutocompleteProps } from 'components/technical/inputs/Autocomplete/GSingleAutocomplete.props.ts';

export const createMultifactorBasedPortfolioInput = (
  input: Partial<MultifactorBasedFormOutputFields>
): Omit<IRebalancedPortfolioMultifactorRuleInput, 'filters'> => {
  return {
    longAssets: input.longAssets ?? 0,
    shortAssets: input.shortAssets ?? 0,
    minFactors: input.minFactors ?? 0,
    multifactorId: input.multifactor?.multifactor.id ?? 0,
  };
};

const MultifactorBasedPortfolioFormFields = ({
  multifactors,
  width,
}: {
  multifactors: {
    maxFactors: number;
    multifactor: Pick<IMultiFactor, 'id' | 'name'>;
  }[];
  width: GInputProps['width'] & GAutocompleteProps<unknown>['width'];
}): ReactElement => {
  const multifactorOptions = createMultifactorOptions(multifactors);
  const { trigger } = useFormContext<MultifactorBasedFormInputFields>();
  return (
    <>
      <FormInput<MultifactorBasedFormInputFields>
        name={'longAssets'}
        type="number"
        width={width}
        label="Long assets"
        showLabelAboveInput
      />
      <FormInput<MultifactorBasedFormInputFields>
        name={'shortAssets'}
        type="number"
        width={width}
        label="Short assets"
        showLabelAboveInput
      />
      <FormStaticSingleAutocomplete<LoadMultifactorFormInputFields>
        name={'multifactor'}
        width={width}
        label="Choose a multifactor"
        options={multifactorOptions}
        onChange={() => {
          trigger('minFactors');
        }}
        showLabelAboveInput
      />

      <FormInput<MultifactorBasedFormInputFields>
        name={'minFactors'}
        type="number"
        width={width}
        label="Minimum factors"
        showLabelAboveInput
      />
    </>
  );
};

export default MultifactorBasedPortfolioFormFields;
